import './App.css';
import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./public/assets/css/all.css";
import "./public/assets/css/bootstrap.min.css";
import "./public/assets/css/boxicons.min.css";
import "./public/assets/css/bootstrap-icons.css";
import "./public/assets/css/swiper-bundle.css";
import "./public/assets/css/animate.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-modal-video/css/modal-video.css";
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter } from 'react-router-dom';
import ContextProvider from './components/Redux/ContextProvider';
import Layout from './components/Layout';
import './public/assets/style.scss'

function App() {

    useEffect(() => {
  
      AOS.init({
        duration: 1000,
        once: false,
        easing: "ease-in-out"
      });
  
      // // show loader for 2 seconds
      // const timer = setTimeout(() => {
      //   setLoading(false);
      // }, 2000);
  
      // return () => clearTimeout(timer);
  
    }, []);

  return (
    <BrowserRouter>
      <ContextProvider>
        <Layout />
      </ContextProvider>
    </BrowserRouter>

  );
}

export default App;
